/**
 * Application Configuration
 *
 * Environment variables for connecting to backend services.
 * In production, these come from Lovable's environment settings.
 */

export const config = {
  // Self-hosted API Backend (Coolify)
  apiUrl: import.meta.env.VITE_API_URL || 'https://sales-api.ait.best',

  // Henry AI API — serves /api/chat/*, /api/tools, /api/commands
  // Falls back to apiUrl when not set (backwards compatible)
  henryApiUrl: import.meta.env.VITE_HENRY_API_URL || import.meta.env.VITE_API_URL || 'https://sales-api.ait.best',

  // Supabase (for auth) - Lovable injects these when connected
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || 'https://xnvjefkhujyfporvhpvx.supabase.co',
  // Supabase anon key is a PUBLIC client-side key (RLS enforces security, not key secrecy).
  // This is the standard Supabase pattern — the key is visible in browser DevTools regardless.
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhudmplZmtodWp5ZnBvcnZocHZ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc1MzkyMDksImV4cCI6MjA4MzExNTIwOX0.eQYfURAfHo190dFpgcVV6tTtvWSK_G_RPgJrv7ZtlDc',

  // Feature flags
  enableMockData: import.meta.env.VITE_ENABLE_MOCK_DATA === 'true',
} as const;

// Log config status in development
if (import.meta.env.DEV) {
  console.log('🔧 Config loaded:', {
    apiUrl: config.apiUrl,
    henryApiUrl: config.henryApiUrl,
    supabaseUrl: config.supabaseUrl,
    hasAnonKey: !!config.supabaseAnonKey,
    anonKeyLength: config.supabaseAnonKey?.length || 0,
  });

  // Warn about common issues
  if (!config.supabaseAnonKey) {
    console.warn('⚠️ VITE_SUPABASE_ANON_KEY is not set - authentication will fail');
  }
  if (config.apiUrl === 'https://sales-api.ait.best') {
    console.warn('⚠️ Using production API URL - set VITE_API_URL=http://localhost:8000 for local dev');
  }
}
